import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { PATHS } from "@/config/paths";

export function NotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({ to: PATHS.DASHBOARD });
  }, [navigate]);

  return null;
}
